import Constants from '../config/const';
import { loadHanging, saveHangingAll } from '../config/api';

export const load = () => (dispatch, getState) => {
  const { canvas: { wallId } } = getState();
  dispatch({ type: Constants.hangings.load });
  loadHanging(wallId).then(({ hangingMarks }) => {
    dispatch({
      type: Constants.hangings.loaded,
      hangingMarks
    });
  });
};

export const update = (first, second, kind, isAdd) => ({
  type: Constants.hangings.update, first, second, kind, isAdd
});

export const reset = () => ({
  type: Constants.hangings.reset
});

export const dismissStatus = () => ({
  type: Constants.hangings.dismissStatus
});

const SAVED_TOAST_MS = 2000;

export const save = (image) => (dispatch, getState) => {
  const { hangings: { hangingMarks }, canvas: { wallId } } = getState();
  dispatch({ type: Constants.hangings.saving });
  saveHangingAll(wallId, hangingMarks, image).then(({ hangingMarks: newMarks }) => {
    dispatch({ type: Constants.hangings.saved, hangingMarks: newMarks });
    setTimeout(() => dispatch({ type: Constants.hangings.dismissStatus }), SAVED_TOAST_MS);
  }).catch((error) => {
    const message = (error && (error.statusText || error.message)) || 'Network error';
    dispatch({ type: Constants.hangings.failed, error: message });
    setTimeout(() => dispatch({ type: Constants.hangings.dismissStatus }), SAVED_TOAST_MS);
  });
};
